import { Routes, Route } from 'react-router-dom'
import Temperatures from './haccp/Temperatures'
import Equipment from './haccp/Equipment'
import TemperatureRecords from './haccp/TemperatureRecords'
import Zones from './haccp/Zones'
import Maintenance from './haccp/Maintenance'
import CleaningByZone from './haccp/CleaningByZone'
import Dashboard from './haccp/Dashboard'

export default function HACCP() {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="temperatures" element={<Temperatures />} />
        <Route path="equipment" element={<Equipment />} />
        <Route path="temperature-records" element={<TemperatureRecords />} />
        <Route path="zones" element={<Zones />} />
        <Route path="cleaning" element={<CleaningByZone />} />
        <Route path="cleaning-by-zone" element={<CleaningByZone />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="alerts" element={<div>Alertas APPCC</div>} />
      </Routes>
    </div>
  )
}
